export const PersonalIdContent = {
  personalIdTitle: 'Provide a few more details',
  personalIdPlaceholder: 'Social Security number',
  errorMsg: 'Your entry is invalid.',
};
